/* this file is transformed by vux-loader */
/* eslint-disable */
import ddRouter from './Dingding/router';
import appRouter from './App/router'; // import ddRequestConfig from './Dingding/request-config'
// import appRequestConfig from './App/request-config'

var isDingding = false;

var _ref = isDingding ? ddRouter : appRouter,
    routerBefore = _ref.routerBefore,
    routerAfter = _ref.routerAfter; // const {request,responce} = isDingding ? ddRequestConfig : appRequestConfig


export { routerBefore, routerAfter };